export const defaultErrorBoundaryProps = {
    packageName: process.env.APP_NAME ?? '',
    packageOwner: process.env.PROJECT_OWNER ?? '',
    packageVersion: process.env.APP_VERSION ?? ''
}
